import Client from "./_client";

export const getCodeChallenges = async (filters = {}) => {
    let url = "/codeChallenge?";

    Object.keys(filters).forEach((key) => {
        if (filters[key]) url += `${key}=${filters[key]}&`;
    });

    const result = await new Client({
        path: url,
    }).get();

    if (!(result.ok || result.code === 200))
        throw new Error(result.message || "unable to fetch code challenges!");

    return result.data || [];
}

export const saveCodeChallenges = async (filters = {}) => {
    let url = "/codeChallenge?";

    Object.keys(filters).forEach((key) => {
        if (filters[key]) url += `${key}=${filters[key]}&`;
    });

    const result = await new Client({
        path: url,
        payload: {}
    }).post();

    if (!(result.ok || result.code === 200))
        throw new Error(result.message || "unable to save code challenges!");

    return result.data || [];
}

export const saveCodeChallengesInBulk = async (codeChallenges, user) => {
    let url = "/codeChallenge/bulk?";

    const result = await new Client({
        path: url,
        payload: {
            codeChallenges,
            user
        }
    }).post();

    if (!(result.ok || result.code === 200))
        throw result;

    return result.data || [];
}

export const deleteCodeChallengeById = async (codeChallengeId) => {
    let url = `/codeChallenge/${codeChallengeId}`;

    const result = await new Client({
        path: url,
        payload: {}
    }).delete();

    if (!(result.ok || result.code === 200))
        throw new Error(result.message || "unable to delete code challenges!");

    return result.data || [];
}